'use client'

/**
 * Navigation hooks - use navigationMachine (XState)
 * Replaces Zustand useNavigationStore selectors
 */
import { useNavigationMachineOptional } from '@/machines'

export function useNavigation() {
  const api = useNavigationMachineOptional()
  return api ? api[0].context.navigation : []
}

export function useViewPermissions() {
  const api = useNavigationMachineOptional()
  const real = api ? api[0].context.viewPermissions : []
  // E2E escape hatch: when Playwright sets window.__E2E_VIEW_PERMS__
  // to a permission list (typically ['ADMIN_GROUP', ...]), synthesize
  // a permission record per view so ViewGuard lets admin pages render
  // without a real superadmin fixture. Dev-only — only effective when
  // import.meta.env.DEV.
  if (typeof window !== 'undefined' && import.meta.env.DEV) {
    const overrides = (window as { __E2E_VIEW_PERMS__?: string[] }).__E2E_VIEW_PERMS__
    if (Array.isArray(overrides) && overrides.length > 0) {
      const synthesized = overrides.map((name) => ({
        id: name,
        name,
        order: 0,
      }))
      return [...real, ...synthesized] as typeof real
    }
  }
  return real
}

export function useActiveMenus() {
  const api = useNavigationMachineOptional()
  return api ? api[0].context.activeMenus : []
}

export function useNavigationLoading() {
  const api = useNavigationMachineOptional()
  return api ? api[0].context.isLoading : false
}

export function useNavigationInitialized() {
  const api = useNavigationMachineOptional()
  return api ? api[0].context.isInitialized : false
}
